// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"80d46854","838":"f7879e6e"}[chunkId] + ".chunk.js";
};